/* PrimeBuild – Kit estrella (pbf): página detallada de un producto (plantillas product.<nombre>.json
   hechas con las secciones pbf-*). No hay nada de un producto concreto en este archivo.
   - Selector en tarjetas (bloque pbf-selector) y guía de opciones (sección pbf-opciones): al elegir,
     se cambia la variante en el selector original de Shopify (oculto o visible), así el precio, la foto,
     el botón de añadir al carrito y la barra fija siguen funcionando como siempre.
   - Todo lo que depende de la variante elegida (nombre, precio real, texto de la opción) se pinta solo.
   - El botón "Add to cart" del cierre usa el botón del módulo de compra (mismo carrito, mismo aviso).
   - Los botones que suben a la compra ponen el foco en la opción elegida (teclado y lectores de pantalla).
   - Mientras se ve la caja del cierre, la barra fija de compra de Shopify se aparta (no hay dos
     botones de añadir al carrito uno encima de otro).
   - La variante elegida se pinta al momento, pero se comprueba que Shopify la confirma (evento
     "variant:update" del tema). Si no la confirma, se repite la petición una vez y, si tampoco, se
     vuelve a pintar la variante que de verdad tiene el formulario de compra.
   - Las cintas en movimiento se paran con el botón de pausa de la ficha normal (assets/pbp-marca.js).
   Los precios vienen de Shopify (ya con formato), nunca se calculan aquí. */
(function () {
  if (window.__pbfInit) return;
  window.__pbfInit = true;

  var V = {};       // variantes por id
  var L = {};       // nombres para enseñar: "posición de la opción|valor" -> { n: nombre, d: texto }
  var hasLabels = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function collect() {
    document.querySelectorAll('script[data-pbf-variants]').forEach(function (s) {
      try {
        JSON.parse(s.textContent).forEach(function (v) { if (!V[String(v.id)]) V[String(v.id)] = v; });
      } catch (e) {}
    });
    // 1) Nombres del selector en tarjetas (mandan)  2) nombres escritos en el cierre (ajuste "nombres")
    // 3) nombres de las tarjetas de la guía. Los dos primeros van en el orden en que están en la página.
    document.querySelectorAll('script[data-pbf-labels]').forEach(function (s) {
      try {
        var o = JSON.parse(s.textContent);
        Object.keys(o).forEach(function (k) { if (k !== '_' && !L[k]) { L[k] = o[k]; hasLabels = true; } });
      } catch (e) {}
    });
    document.querySelectorAll('[data-pbf-card]').forEach(function (c) {
      var k = (c.getAttribute('data-pbf-opt') || '0') + '|' + c.getAttribute('data-pbf-card');
      var n = c.getAttribute('data-pbf-name');
      if (n && !L[k]) { L[k] = { n: n, d: '' }; if (n !== c.getAttribute('data-pbf-card')) hasLabels = true; }
    });
  }

  /* Nombre claro de una variante: cada valor con su nombre editable ("1 Base + 3 Balls", "Black / M") */
  function displayName(v) {
    if (!v) return '';
    if (!v.o || !v.o.length) return v.title || '';
    return v.o.map(function (val, i) {
      var e = L[i + '|' + val];
      return (e && e.n) || val;
    }).join(' / ');
  }
  function detailText(v) {
    if (!v || !v.o) return '';
    for (var i = 0; i < v.o.length; i++) {
      var e = L[i + '|' + v.o[i]];
      if (e && e.d) return e.d;
    }
    return '';
  }

  function productSection() {
    var sel = document.querySelector('[data-pbf-selector]');
    return (sel && sel.closest('.shopify-section')) || document.querySelector('.shopify-section:has(product-form-component)');
  }
  function picker() {
    var sec = productSection();
    return (sec && sec.querySelector('variant-picker')) ||
      document.querySelector('variant-picker[data-template-product-match="true"]');
  }
  function productForm() {
    var sec = productSection();
    return (sec && sec.querySelector('product-form-component')) || document.querySelector('product-form-component');
  }
  /* La variante que de verdad tiene el formulario de compra (la que se añadiría al carrito) */
  function formId() {
    var f = productForm();
    var i = f && f.querySelector('input[name="id"]');
    return i && i.value ? String(i.value) : null;
  }
  function currentId() {
    var id = formId();
    if (id && V[id]) return id;
    var el = document.querySelector('[data-pbf-current]');
    if (el) return el.getAttribute('data-pbf-current');
    return id;
  }

  function reloadWith(id) {
    var u = new URL(window.location.href);
    u.searchParams.set('variant', id);
    window.location.href = u.toString();
  }

  /* Variantes con ese valor en la opción idx, la mejor primero: misma combinación en las demás
     opciones que la variante actual y, si puede ser, que se pueda comprar */
  function bestWith(idx, value) {
    var cur = V[currentId()];
    var best = null;
    Object.keys(V).forEach(function (id) {
      var v = V[id];
      if (!v.o || v.o[idx] !== value) return;
      var same = !!(cur && cur.o && v.o.every(function (x, k) { return k === idx || x === cur.o[k]; }));
      var score = (same ? 2 : 0) + (v.available ? 1 : 0);
      if (!best || score > best.score) best = { id: id, score: score, same: same };
    });
    return best;
  }
  /* Variante exacta que queda al cambiar solo la opción idx (null si esa combinación no existe) */
  function variantWith(idx, value) {
    var b = bestWith(idx, value);
    return b && b.same ? b.id : null;
  }

  /* ---------- Elegir un valor de una opción (posición idx) en el selector de Shopify ---------- */
  /* El botón de opción (o el desplegable) del selector de Shopify que corresponde a ese valor */
  function pickerControl(vp, idx, value) {
    var fs = vp.querySelector('fieldset[data-fieldset-index="' + idx + '"]');
    var radios = fs ? fs.querySelectorAll('input[type="radio"]') : [];
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) return radios[i];
    }
    var selects = vp.querySelectorAll('select');
    for (var s = 0; s < selects.length; s++) {
      for (var j = 0; j < selects[s].options.length; j++) {
        if (selects[s].options[j].value === value) return selects[s];
      }
    }
    return null;
  }
  /* Marca ese valor. force: repite la petición del tema aunque ya estuviera marcado.
     silent: lo marca sin avisar al tema (solo para dejar el selector como está el formulario). */
  function setControl(c, value, force, silent) {
    var changed = false;
    if (c.tagName === 'SELECT') {
      if (c.value !== value) { c.value = value; changed = true; }
    } else if (!c.checked) {
      if (silent) c.checked = true;
      else { c.click(); return; }
      changed = true;
    }
    if (silent) return;
    if (changed || force) c.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function selectOption(idx, value, force) {
    var vp = picker();
    var c = vp && pickerControl(vp, idx, value);
    if (c) {
      setControl(c, value, force, false);
      return true;
    }
    // Sin selector de Shopify en la página: se busca la variante y se recarga con ella en la dirección
    var best = bestWith(idx, value);
    if (best && best.id !== currentId()) reloadWith(best.id);
    return false;
  }

  /* ---------- Variante pedida, pendiente de que Shopify la confirme ----------
     Al elegir, la variante se pinta al momento; quien cambia de verdad el precio, la foto y el
     formulario es el tema, con una petición a Shopify que termina en el evento "variant:update".
     Si esa petición falla (sin conexión, demasiadas peticiones...), el evento no llega: se repite la
     petición una vez y, si tampoco llega, se vuelve a pintar la variante que de verdad tiene el
     formulario. Así no queda a la vista una variante distinta de la que se añadiría al carrito. */
  var pending = null;
  var WAIT_FIRST = 4000;
  var WAIT_RETRY = 6000;
  function expect(id) {
    if (pending) clearTimeout(pending.t);
    pending = { id: String(id), n: 0, atc: false, t: setTimeout(unconfirmed, WAIT_FIRST) };
  }
  function refetch(id) {
    var v = V[id];
    var vp = picker();
    if (!v || !v.o || !v.o.length || !vp) return false;
    var last = v.o.length - 1;
    for (var i = 0; i <= last; i++) {
      var c = pickerControl(vp, i, v.o[i]);
      if (!c) return false;
      setControl(c, v.o[i], i === last, false);
    }
    return true;
  }
  function syncPicker(id) {
    var v = V[id];
    var vp = picker();
    if (!v || !v.o || !vp) return;
    for (var i = 0; i < v.o.length; i++) {
      var c = pickerControl(vp, i, v.o[i]);
      if (c) setControl(c, v.o[i], false, true);
    }
  }
  function unconfirmed() {
    var pnd = pending;
    if (!pnd) return;
    if (pnd.n < 1 && refetch(pnd.id)) {
      pnd.n++;
      pnd.t = setTimeout(unconfirmed, WAIT_RETRY);
      return;
    }
    pending = null;
    var real = formId();
    if (real && real !== pnd.id && V[real]) {
      syncPicker(real);
      render(real);
    }
    // Se había pedido añadir al carrito: no se añade nada; se sube a la compra, que enseña lo que hay
    if (pnd.atc) goToBuy(true, true);
  }
  /* Shopify ha confirmado una variante de este producto */
  function settle(id) {
    var pnd = pending;
    if (!pnd) return;
    clearTimeout(pnd.t);
    pending = null;
    if (!pnd.atc) return;
    if (pnd.id === id) setTimeout(addToCart, 0);
    else goToBuy(true, true);
  }
  function addToCart() {
    var f = productForm();
    var btn = f && f.querySelector('[ref="addToCartButton"]');
    if (btn && !btn.disabled) {
      btn.dataset.puppet = 'true';
      btn.click();
    } else {
      goToBuy(true, true);
    }
  }

  /* ---------- Elegir una variante concreta (selector en tarjetas: productos de una sola opción) ---------- */
  function selectVariant(id) {
    id = String(id);
    if (!V[id]) collect();
    var v = V[id];
    if (!v) return false;
    var vp = picker();
    if (vp) {
      var ok = true;
      var last = v.o.length - 1;
      // Si el selector de Shopify ya tiene marcada esa variante pero el formulario no (una petición
      // anterior falló), se repite la petición
      var stale = formId() !== id;
      for (var i = 0; i <= last; i++) ok = selectOption(i, v.o[i], stale && i === last) && ok;
      if (ok) { render(id); expect(id); return true; }
    }
    reloadWith(id);
    return false;
  }

  /* ---------- Pintar la variante elegida en todas partes ---------- */
  function render(id) {
    if (!id) return;
    id = String(id);
    var v = V[id];
    if (!v) return;

    document.querySelectorAll('[data-pbf-radio]').forEach(function (r) { r.checked = r.value === id; });
    document.querySelectorAll('[data-pbf-card]').forEach(function (c) {
      var idx = parseInt(c.getAttribute('data-pbf-opt') || '0', 10);
      var on = v.o && v.o[idx] === c.getAttribute('data-pbf-card');
      c.classList.toggle('is-selected', on);
      var b = c.querySelector('[data-pbf-pick]');
      if (b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var t = b.querySelector('[data-pbf-btn-text]');
        if (t) t.textContent = on ? b.getAttribute('data-label-on') : b.getAttribute('data-label');
      }
    });

    var name = displayName(v);
    document.querySelectorAll('[data-pbf-sel-name]').forEach(function (el) { el.textContent = name; });
    document.querySelectorAll('[data-pbf-sel-price]').forEach(function (el) { el.textContent = v.price; });
    document.querySelectorAll('[data-pbf-sel-compare]').forEach(function (el) {
      var n = el.querySelector('[data-pbf-sel-compare-n]');
      if (n) n.textContent = v.compare || '';
      el.hidden = !v.compare;
    });
    var det = detailText(v);
    document.querySelectorAll('[data-pbf-contents]').forEach(function (el) {
      el.textContent = det;
      el.hidden = !det;
    });
    document.querySelectorAll('[data-pbf-atc]').forEach(function (b) {
      b.disabled = !v.available;
      var t = b.querySelector('[data-pbf-atc-text]');
      if (t) t.textContent = v.available ? (b.getAttribute('data-label') + ' · ' + v.price) : b.getAttribute('data-label-sold');
    });
    stickyLabels(v);
  }

  /* Barra fija de compra: el nombre claro de la variante (solo si hay nombres editados).
     La foto pequeña es decorativa (al lado ya están el nombre y la variante): alt vacío. */
  function stickyLabels(v) {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar || !v) return;
    if (hasLabels) {
      var vt = bar.querySelector('.sticky-add-to-cart__variant');
      var name = displayName(v);
      if (vt && name && vt.textContent.trim() !== name) vt.textContent = name;
    }
    var im = bar.querySelector('.sticky-add-to-cart__image-img');
    if (im && im.getAttribute('alt') !== '') im.setAttribute('alt', '');
  }

  /* Mientras se ve la caja del cierre (con su propio "Add to cart"), la barra fija de Shopify se aparta */
  var finalSeen = [];
  function initFinal() {
    if (!('IntersectionObserver' in window)) return;
    var root = document.documentElement;
    document.querySelectorAll('[data-pbf-final]').forEach(function (box) {
      if (box.__pbfFinal) return;
      box.__pbfFinal = true;
      var st = { on: false };
      finalSeen.push(st);
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { st.on = en.isIntersecting && document.body.contains(box); });
        root.classList.toggle('pbf-final-on', finalSeen.some(function (x) { return x.on; }));
      }).observe(box);
    });
  }

  /* ---------- Subir hasta la compra ---------- */
  function goToBuy(focusOption, toOptions) {
    var sel = document.querySelector('[data-pbf-selector][data-pbf-ready]');
    var vp = picker();
    var top = document.getElementById('pbx-comprar');
    // Con selector en tarjetas se va al selector; al elegir desde la guía, al selector de Shopify;
    // si no, al principio del módulo de compra.
    var anchor = sel || (toOptions && vp && vp.offsetParent !== null ? vp : null);
    var y;
    if (anchor) y = anchor.getBoundingClientRect().top + window.pageYOffset - 110;
    else if (top) y = top.getBoundingClientRect().top + window.pageYOffset - 12;
    else return;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (!focusOption) return;
    var r = null;
    if (sel) r = sel.querySelector('[data-pbf-radio]:checked') || sel.querySelector('[data-pbf-radio]');
    else if (vp && vp.offsetParent !== null) r = vp.querySelector('input[type="radio"]:checked') || vp.querySelector('input[type="radio"], select');
    if (!r) {
      var f = productForm();
      r = f && f.querySelector('[ref="addToCartButton"]');
    }
    if (r) setTimeout(function () { try { r.focus({ preventScroll: true }); } catch (e) { r.focus(); } }, reduce ? 0 : 450);
  }

  /* ---------- Eventos ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-pbf-radio]')) selectVariant(t.value);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var pick = e.target.closest('[data-pbf-pick]');
    if (pick) {
      e.preventDefault();
      var pIdx = parseInt(pick.getAttribute('data-pbf-opt') || '0', 10);
      var pVal = pick.getAttribute('data-pbf-pick');
      var next = variantWith(pIdx, pVal);
      selectOption(pIdx, pVal, !!next && formId() !== next);
      // Se pinta ya la variante que va a quedar elegida y se espera a que Shopify la confirme
      // (variant:update); si no la confirma, se vuelve a la que tiene el formulario
      if (next) { render(next); expect(next); }
      goToBuy(true, true);
      return;
    }
    var go = e.target.closest('[data-pbf-go="buy"]');
    if (go && (document.getElementById('pbx-comprar') || document.querySelector('[data-pbf-selector]'))) {
      e.preventDefault();
      goToBuy(true, false);
      return;
    }
    var atc = e.target.closest('[data-pbf-atc]');
    if (atc) {
      e.preventDefault();
      // Variante recién elegida y todavía sin confirmar: se añade en cuanto Shopify la confirme
      if (pending) { pending.atc = true; return; }
      addToCart();
    }
  });

  document.addEventListener('variant:update', function (e) {
    var r = e.detail && e.detail.resource;
    if (!r || !r.id) return;
    var id = String(r.id);
    if (!V[id]) return; // variante de otro producto (por ejemplo, una tarjeta de producto relacionado)
    render(id);
    settle(id);
    // La barra fija se vuelve a pintar con los textos de Shopify: volver a poner los nuestros
    setTimeout(function () { stickyLabels(V[id]); }, 60);
    setTimeout(function () { stickyLabels(V[id]); }, 400);
  });

  document.addEventListener('cart:update', function (e) {
    var f = productForm();
    var btn = f && f.querySelector('[ref="addToCartButton"]');
    if (btn) btn.dataset.puppet = 'false';
    // Aviso "Añadido al carrito": el nombre claro de la variante (el del producto lo pone la ficha normal)
    var d = e && e.detail;
    if (!hasLabels || !d || !d.data || d.data.source !== 'product-form-component' || d.data.didError) return;
    var v = V[currentId()];
    setTimeout(function () {
      var toast = document.querySelector('.pbp-cart-toast');
      if (!toast) return;
      var vt = toast.querySelector('.pbp-cart-toast__variant');
      var name = displayName(v);
      if (vt && name) vt.textContent = name;
    }, 30);
  });

  /* ---------- Inicio ---------- */
  /* Variante elegida al entrar (ajuste del selector en tarjetas), si la dirección no trae ya una */
  function preselect() {
    var box = document.querySelector('[data-pbf-selector]');
    if (!box || box.__pbfPre) return;
    box.__pbfPre = true;
    if (/[?&]variant=/.test(window.location.search)) return;
    var want = (box.getAttribute('data-pbf-default') || '').trim().toLowerCase();
    if (!want) return;
    var cur = V[currentId()];
    if (cur && cur.o && String(cur.o[0]).toLowerCase() === want) return;
    for (var id in V) {
      var v = V[id];
      if (v.available && v.o && String(v.o[0]).toLowerCase() === want) { selectVariant(id); return; }
    }
  }

  /* ---------- Móvil: barra fija antes de llegar a la compra ---------- */
  /* Solo se ve mientras el módulo de compra todavía no ha entrado en pantalla (y los botones de la
     portada ya no se ven). Después manda el propio módulo y, más abajo, la barra de compra de Shopify. */
  var mbarReady = false;
  function initMbar() {
    var bar = document.querySelector('[data-pbf-mbar]');
    if (!bar || mbarReady) return;
    var buy = document.getElementById('pbx-comprar') || productSection() || productForm();
    var ctas = document.querySelector('.pbf-hero__ctas');
    if (!buy || !('IntersectionObserver' in window)) return;
    mbarReady = true;
    var ctasOn = false;
    var link = bar.querySelector('a');
    var ticking = false;
    function update() {
      ticking = false;
      var notYet = buy.getBoundingClientRect().top > window.innerHeight - 40;
      // No tapar la portada al entrar: la barra sale en cuanto se empieza a bajar
      var moved = (window.pageYOffset || document.documentElement.scrollTop || 0) > 48;
      var on = moved && notYet && !ctasOn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (link) link.tabIndex = on ? 0 : -1;
    }
    if (ctas) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { ctasOn = en.isIntersecting; });
        update();
      }).observe(ctas);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function init() {
    collect();
    initMbar();
    initFinal();
    // Selector en tarjetas listo (sin selector de Shopify, elegir recarga la página con ?variant=)
    document.querySelectorAll('[data-pbf-selector]').forEach(function (s) { s.setAttribute('data-pbf-ready', ''); });
    document.documentElement.classList.remove('pbf-fallback');
    var id = currentId();
    render(id);
    // Elegir la variante por defecto cuando el selector de Shopify ya está listo
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('variant-picker').then(function () { setTimeout(preselect, 60); });
    } else {
      preselect();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { init(); });
})();
